import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast, { Toaster } from "react-hot-toast";
import * as services from "./../services/services";
import logo from "../images/itaam-company-2.png";

const schema = yup.object().shape({
  username: yup.string().required("กรุณากรอกชื่อผู้ใช้"),
  password: yup
    .string()
    .min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร")
    .required("กรุณากรอกรหัสผ่าน"),
});

export default function Login() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { username: "", password: "" },
  });
  const onSubmit = async (data) => {
    const payload = { username: data.username, password: data.password };
    try {
      const Response = await services.login(payload);
      const Data = Response.data;

      if (!Data.success) {
        toast.error(Data.error || "เข้าสู่ระบบไม่สำเร็จ");
        return;
      }

      const { accessToken } = Data.data;
      localStorage.setItem("accessToken", JSON.stringify(accessToken));

      const payloadbow = { email: "test@example.com", password: 1234 };
      const ResponseBow = await services.loginBow(payloadbow);
      const { access } = ResponseBow.data;
      localStorage.setItem("bow_accessToken", access);
      navigate("/home");
    } catch (error) {
      toast.error(error?.response?.data?.error || "เกิดข้อผิดพลาด");
    }
  };

  return (
    <div className="min-h-screen w-full bg-white p-6 flex flex-col items-center">
      <Toaster />

      {/* โลโก้ */}
      <img src={logo} alt="logo" className="w-55 mt-20" />

      {/* ข้อความหัวข้อ */}
      <h1 className="text-2xl font-bold text-gray-900 text-center mt-6">
        BOW HIS.
      </h1>
      <p className="text-gray-700 text-center text-base">
        โปรแกรมดูแลลูกค้าสำหรับโรงพยาบาลสัตว์
      </p>
      <p className="text-gray-500 text-center text-sm mb-3">
        Empowering Vets, Enriching Care
      </p>
      {/* ลิงก์สมาชิก */}
      <h3 className="text-xl font-bold text-gray-900 text-center mb-10">
        สำหรับสัตวแพทย์
      </h3>
      {/* <p className="text-sm text-gray-500 mb-6">
        เป็นสมาชิก?{" "}
        <span className="text-orange-500 font-semibold">เข้าสู่ระบบ</span>
      </p> */}

      {/* ฟอร์ม */}
      <form onSubmit={handleSubmit(onSubmit)} className="w-full max-w-xs">
        <input
          type="text"
          placeholder="Username"
          {...register("username")}
          className="w-full px-4 py-3 border rounded-md mb-2"
        />
        {errors.username && (
          <p className="text-red-500 text-xs mb-2">{errors.username.message}</p>
        )}

        <input
          type="password"
          placeholder="Password"
          {...register("password")}
          className="w-full px-4 py-3 border rounded-md mb-2"
        />
        {errors.password && (
          <p className="text-red-500 text-xs mb-2">{errors.password.message}</p>
        )}

        {/* remember / forgot */}
        <div className="flex justify-between mb-4 text-sm">
          <label className="flex items-center">
            <input type="checkbox" className="mr-2" /> remember me
          </label>
        </div>

        {/* ปุ่ม Login สีส้ม */}
        <button className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-md">
          Log In
        </button>

        <p className="text-gray-700 text-center text-base mt-10">
          สถานพยาบาล สนใจระบบบันทึกสมุดวัคซีนออนไลน์ ติดต่อได้ที่ line :{" "}
          <a
            href="https://lin.ee/wJGEwQi"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            @bowpet
          </a>
        </p>
      </form>
    </div>
  );
}
